import {ConsoleLogger} from '@microsoft/signalr/dist/esm/Utils';

export const parseData = (detailsProduct) => {
  const listRequestText = detailsProduct.listRequestText;
  const listPlanDtlText = detailsProduct.listPlanDtlText;
  const isCalllogsExists = detailsProduct.isCalllogsExists;
  const userPhone = detailsProduct.userPhone;
  const data = detailsProduct.listSubPage.map((item) => {
    const isCustomerBusiness = item.isCustomerBusiness;
    const detailsType = item.detailsType;
    const footerProduct = item.footer;
    const listDalDetailsCliSection = item?.listDalDetailsCliSection?.map((section) => {
      const isColumnView = section.isColumnView;
      const data = section.listCliDetail !== null && section.listCliDetail.length > 0 ? section?.listCliDetail : section?.allFitcherDetail;
      const detailsCliColumnTitle = section.detailsCliColumnTitle;
      const subSection = section.subSection;
      const footerSubSection = section?.footer;
      return {
        title: section.title,
        data,
        detailsCliColumnTitle,
        isColumnView,
        subSection,
        footerSubSection,
        // isDiscount
      };
    });
    return {
      listDalDetailsCliSection,
      listRequestText,
      listPlanDtlText,
      detailsType,
      footerProduct,
      isCustomerBusiness,
    };
  });
  return {
    data,
    listRequestText,
    listPlanDtlText,
    isCalllogsExists,
    userPhone,
  };
};

export const updateURLParameter = (param, value) => {
  const url = new URL(window.location);
  url.searchParams.set(param, value);
  console.debug(`[updateURLParameter] window.history.pushState ${url}`);
  window.history.pushState({}, '', url);
};

export const getSessionStorage = () => {
  const data = sessionStorage.getItem('invoiceIframeData');
  if (data) {
    sessionStorage.removeItem('invoiceIframeData');
    const selfCareInvoiceData = JSON.parse(data);
    updateURLParameter('id', selfCareInvoiceData.id);
    return selfCareInvoiceData;
  }
  return null;
};

export const openBase64ToPdfFile = (base64) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], {type: 'application/pdf'});
  const blobURL = URL.createObjectURL(blob);
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    window.location.href = blobURL;
  } else {
    window.open(blobURL, '_blank');
  }
};

export const isMonthWithinThreeMonths = (cycleDate) => {
  if (!cycleDate) return false;
  const now = new Date();
  const currentMonth = now.getMonth(); // 0-11 (January is 0, December is 11)
  const currentYear = now.getFullYear();

  const year = parseInt(cycleDate.toString().substring(0, 4), 10);
  const month = parseInt(cycleDate.toString().substring(4, 6), 10) - 1; // Subtract 1 because months are zero-based in JavaScript

  const monthDifference = (currentYear - year) * 12 + (currentMonth - month);

  return monthDifference >= 0 && monthDifference <= 3;
};
